import React from 'react';
import { Modal, Form, Input, ColorPicker } from 'antd';
import { useTheme } from '../contexts/ThemeContext';

const ThemeSettings = ({ open, onClose }) => {
  const { theme, updateTheme } = useTheme();
  const [form] = Form.useForm();

  const handleSubmit = (values) => {
    // 确保颜色值是十六进制格式
    const formattedValues = {
      ...values,
      backgroundColor: values.backgroundColor?.toHexString() || theme.backgroundColor,
      cardColor: values.cardColor?.toHexString() || theme.cardColor,
    };
    updateTheme(formattedValues);
    onClose();
  };

  return (
    <Modal
      title="主题设置"
      open={open}
      onCancel={onClose}
      onOk={() => form.submit()}
      okText="确定"
      cancelText="取消"
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={{
          ...theme,
          backgroundColor: theme.backgroundColor,
          cardColor: theme.cardColor,
        }}
        onFinish={handleSubmit}
      >
        <Form.Item
          name="headerTitle"
          label="标题设置"
          rules={[{ required: true, message: '请输入标题' }]}
        >
          <Input placeholder="请输入标题" />
        </Form.Item>

        <Form.Item
          name="backgroundColor"
          label="背景颜色"
        >
          <ColorPicker format="hex" />
        </Form.Item>

        <Form.Item
          name="cardColor"
          label="卡片颜色"
        >
          <ColorPicker format="hex" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ThemeSettings; 